import {Address} from './address';

export class Elderly {
   id: string;
   elderlyFullName: string;
   elderlyAddress: Address;
}
